/**
 * Spicy Custom Theme - Global JavaScript
 */

class SpicyTheme {
  constructor() {
    this.init();
  }

  init() {
    this.setupCart();
    this.setupProductForms();
    this.setupMobileMenu();
    this.setupAnimations();
    this.setupCartDrawerSuppression();
  }

  setupCart() {
    // Cart functionality
    const cartForms = document.querySelectorAll('form[action*="/cart/add"]');
    
    cartForms.forEach(form => {
      if (form.dataset.type === 'add-to-cart-form') {
        return;
      }
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        
        const formData = new FormData(form);
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          const data = await response.json();
          this.updateCartCount(data.item_count);
          this.showCartNotification();
          
          // If cart type is drawer, open it
          if (window.cartType === 'drawer') {
            this.openCartDrawer();
          }
        }
      });
    });
  }

  setupProductForms() {
    // Product variant selection
    const variantSelects = document.querySelectorAll('[name="id"]');
    
    variantSelects.forEach(select => {
      select.addEventListener('change', () => {
        this.updateProductPrice(select);
      });
    });
  }

  setupMobileMenu() {
    const menuToggle = document.querySelector('.mobile-menu-toggle');
    const mobileMenu = document.querySelector('.mobile-menu');
    
    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', () => {
        mobileMenu.classList.toggle('is-open');
        document.body.classList.toggle('menu-open');
      });
    }
  }

  setupAnimations() {
    // Reveal on scroll animations
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    document.querySelectorAll('[data-animate]').forEach(el => {
      observer.observe(el);
    });
  }

  setupCartDrawerSuppression() {
    document.addEventListener(
      'click',
      (event) => {
        const link = event.target.closest('a[href]');
        if (!link) return;
        let url;
        try {
          url = new URL(link.getAttribute('href'), window.location.origin);
        } catch (e) {
          return;
        }
        if (url.pathname.startsWith('/collections')) {
          document.documentElement.classList.add('suppress-cart-drawer');
          setTimeout(() => {
            document.documentElement.classList.remove('suppress-cart-drawer');
          }, 500);
        }
      },
      true
    );
  }

  updateCartCount(count) {
    const cartCountElements = document.querySelectorAll('.cart-count, .header__action-badge--text, [data-cart-count]');
    cartCountElements.forEach(el => {
      el.textContent = count;
      el.classList.add('animate-bounce');
      setTimeout(() => {
        el.classList.remove('animate-bounce');
      }, 500);
    });
  }

  showCartNotification() {
    // Create and show cart notification
    const notification = document.createElement('div');
    notification.className = 'cart-notification';
    notification.textContent = 'Producto agregado al carrito';
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.classList.add('is-visible');
    }, 10);
    
    setTimeout(() => {
      notification.classList.remove('is-visible');
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 3000);
  }

  openCartDrawer() {
    const cartDrawer = document.querySelector('.cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.add('is-open');
      document.body.classList.add('drawer-open');
    }
  }

  updateProductPrice(select) {
    const productId = select.value;
    const priceElement = select.closest('.product-form')?.querySelector('.product-price');
    
    if (priceElement && productId) {
      // Fetch variant price
      fetch(`/products/${select.dataset.productHandle}?view=price&variant=${productId}`)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newPrice = doc.querySelector('.product-price');
          
          if (newPrice) {
            priceElement.innerHTML = newPrice.innerHTML;
          }
        });
    }
  }
}

// Initialize theme when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.spicyTheme = new SpicyTheme();
  });
} else {
  window.spicyTheme = new SpicyTheme();
}

// Export for use in other scripts
window.SpicyTheme = SpicyTheme;

// DeferredMedia class for lazy loading videos and media
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia = window.pauseAllMedia || function() {};
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

